import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import Message from '../Elements/Message/Message';
import $ from 'jquery'
import {ajax} from '../../Context';
import './Login.css';


const AJAX_TYPE = '135791';

// Contact component render contact form
class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            message: [],
            success: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeUsername = this.handleChangeUsername.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);

        $(document).on('focusin',".login-mask form input",function(e){
            e.preventDefault();
           $('body').addClass('keyboard-open');
            window.scrollTo(0, 0);
            document.body.scrollTop = 0;
        });
        $(document).on('focusout',".login-mask form input",function(){
            $('body').removeClass('keyboard-open');
        });
    }

    componentDidMount() {
        var $this = $(ReactDOM.findDOMNode(this));
        $(window).resize(function(){
            var h = $this.outerHeight();
            var w = $this.outerWidth();
            var legit = true;
            if(parseInt(h + 20,10) > $(window).outerHeight()) {
                legit = false;
            }

            if(w < 240) {
                legit = false;
            }

            if(legit) {
                $(document).find(".login-screen.extrem-small").removeClass('extrem-small');
            }else{
                $(document).find(".login-screen").addClass('extrem-small');
            }
        });

    }

    // Change state of input field so text is updated while typing
    handleChangeUsername(e) {
        this.setState({
            username: e.target.value,
        });
    }

    // Change state of input field so text is updated while typing
    handleChangePassword(e) {
        this.setState({
            password: e.target.value
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        $.ajax({
            url: ajax.url + '?type=' + AJAX_TYPE,
            type: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            dataType: 'json',
            data: {
                'username': this.state.username,
                'password': this.state.password,
                'uhash': this.props.hash
            },
            cache: false,
            success: function (data) {
                if(data.success) {
                    this.props.setHash(data.hash);
                    this.props.setSession(true);
                    this.props.loginUser();
                }else{
                    this.props.logoutUser();
                    this.setState({
                        message:['Login failed']
                    });
                }
            }.bind(this),
            error: function () {
                this.props.logoutUser();
                this.setState({
                    message: ['Login failed']
                });
            }.bind(this)
        });
        this.props.changeRoute('');
    }

    render() {

        return (
            <main className="Form">
                <div className="messages">
                    <Message messages={this.state.message} status="danger" />
                </div>
                <form method="POST" action={this.state.ajax} onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <input type="text" name="username" className="form-control" placeholder="Benutzername / E-Mail"
                               value={this.state.username} onChange={this.handleChangeUsername}/>
                    </div>
                    <div className="form-group">
                        <input type="password" name="password" className="form-control" placeholder="Passwort"
                               value={this.state.password} onChange={this.handleChangePassword} />
                    </div>
                    <div className="form-group">
                        <button type="submit" className="btn btn-default no-select">Anmelden</button>
                    </div>
                </form>
                <div className="form-info">
                    <p className="text-center">Sie haben noch keinen Account?</p>
                    <p className="text-center"><a href="https://www.novoferm-extranet.de/" target="_blank" rel="noopener noreferrer" className="no-select">Jetzt registrieren</a></p>
                </div>
                <ul className="list-inline login-footer">
                    <li>
                        <a className="no-select" target="_blank" rel="noopener noreferrer" href="https://www.novoferm-extranet.de/public/impressum.html">Impressum</a>
                    </li>
                    <li>
                        <a className="no-select" target="_blank" rel="noopener noreferrer" href="https://www.novoferm-extranet.de/public/datenschutzerklaerung.html">Datenschutzerklärung</a>
                    </li>
                </ul>

            </main>

        )
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/Components/Login/Login.js